import { FEATURE_NAME } from './consts';

export const DELETE_QUESTION = `${FEATURE_NAME}/DELETE_QUESTION`;

export const MOVE_QUESTION_DOWN = `${FEATURE_NAME}/MOVE_QUESTION_DOWN`;

export const MOVE_QUESTION_UP = `${FEATURE_NAME}/MOVE_QUESTION_UP`;

export const RETRY_FETCH = `${FEATURE_NAME}/RETRY_FETCH`;
